import React, {PureComponent} from 'react';
import './Spacer.scss';

export class Spacer extends PureComponent {

    render = () => {
        return (
            <div className="spacer"/>
        );
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/Spacer/Spacer.jsx